import {API_URL} from '../constants'
import { Amplify, Auth } from "aws-amplify";

export const getUserInfo = async ()=> {
   const res = await Auth.currentAuthenticatedUser().then((user)=>({name:user.username, token:user.signInUserSession.accessToken.jwtToken}));
    return await res;
}
